module.exports = __webpack_public_path__ + "static/media/avatar.a6399afe.jpg";